import { render, staticRenderFns } from "./NavBarBassa.vue?vue&type=template&id=0b2a2106&scoped=true&"
import script from "./NavBarBassa.vue?vue&type=script&lang=js&"
export * from "./NavBarBassa.vue?vue&type=script&lang=js&"
import style0 from "./NavBarBassa.vue?vue&type=style&index=0&id=0b2a2106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2a2106",
  null
  
)

export default component.exports